import React from 'react';
import { translate } from 'react-i18next';
import NotificationInput from './NotificationInput';
import { Typography } from '@material-ui/core';
import AdminStepCard from '../../../components/AdminStepCard/AdminStepCard';
import InfoButton from '../../../components/InfoButton/InfoButton';
import { WorkflowNotifications, WorkflowNotificationsKeys } from '../../../Enums/WorkflowNotifications';
import './NotificationStep.scss';

const WorkplanNotifications = [
    WorkflowNotifications.workplanWillStart,
    WorkflowNotifications.workplanWillStop,
    WorkflowNotifications.workplanHasStarted,
    WorkflowNotifications.workplanPaused,
    WorkflowNotifications.workplanStopped,
]
const ShiftlinesNotifications = [
    WorkflowNotifications.shiftlineWillStart,
    WorkflowNotifications.shiftlineHasStarted,
    WorkflowNotifications.shiftlinePaused,
    WorkflowNotifications.shiftlineStopped,
]
const AssignmentsNotifications = [
    WorkflowNotifications.ownerAdded,
    WorkflowNotifications.ownerPaused,
    WorkflowNotifications.ownerStopped,
    WorkflowNotifications.reliefAdded,
    WorkflowNotifications.reliefRemoved,
    WorkflowNotifications.reliefModified,
]
const timeValueNotifs = [
    WorkflowNotifications.workplanWillStart,
    WorkflowNotifications.workplanWillStop,
    WorkflowNotifications.shiftlineWillStart,
]

const getIsShowTimeInput = (type) => timeValueNotifs.includes(type);

const NotificationStep = ({
    notificationValues, handleSettingPropChange, notificationList, openModal, ...props
}) => {
    const { t: translate} = props;
    const t = (param) => translate(`workplanManager:settings.workflowNotifications.${param}`)

    const getNotificationValue = (type) => notificationValues.find(x => x.type === type);

    const handleChange = (notification) => {
        const otherNotifications = notificationValues.filter(x => x.type !== notification.type);
        handleSettingPropChange('workflowNotifications', [...otherNotifications, notification])
    };

    const componentMapping = (x) => (
                <NotificationInput
                    id={getNotificationValue(x)}
                    notificationValue={getNotificationValue(x)}
                    label={t(`labels.${WorkflowNotificationsKeys[x]}`)}
                    options={notificationList}
                    handleChange={handleChange}
                    hasTimeSelection={getIsShowTimeInput(x)}
                />);


    return (
        <AdminStepCard avatar={9} title={t('title')}>
            <InfoButton
                text={t("customTags.modalButton")}
                onClick={openModal}
                position="left"
                className='info-button'
            />
            <div className='labeledSelects-container'>
                <Typography className="notification--typo">{t('sections.workplanTemplate')}</Typography>
                {WorkplanNotifications.map(componentMapping)}

                <Typography className="notification--typo">{t('sections.shiftlines')}</Typography>
                {ShiftlinesNotifications.map(componentMapping)}

                <Typography className="notification--typo">{t('sections.assignments')}</Typography>
                {AssignmentsNotifications.map(componentMapping)}
            </div>
        </AdminStepCard>
    )
}

export default translate('workplanManager')(NotificationStep);